import { render, staticRenderFns } from "./ListPage.vue?vue&type=template&id=2a15c2a7&scoped=true&"
import script from "./ListPage.vue?vue&type=script&lang=js&"
export * from "./ListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a15c2a7",
  null
  
)

export default component.exports